import { Component } from '@theme/component'
import { fetchConfig } from '@theme/utilities'
import { CartAddEvent } from '@theme/events'

/**
 * A custom element that intercepts form submissions and submits them via AJAX to the cart.
 * Dispatches CartAddEvent on successful addition.
 *
 * @extends Component
 */
export class CartFormComponent extends Component {
  connectedCallback() {
    super.connectedCallback()

    const form = this.querySelector('form')
    if (!form) return

    form.addEventListener('submit', this.#handleSubmit)
  }

  disconnectedCallback() {
    super.disconnectedCallback()

    const form = this.querySelector('form')
    if (!form) return

    form.removeEventListener('submit', this.#handleSubmit)
  }

  #handleSubmit = async (event) => {
    event.preventDefault()

    const form = event.target
    if (!(form instanceof HTMLFormElement)) return

    const button = form.querySelector('button[type="submit"]')
    if (button instanceof HTMLButtonElement) {
      button.disabled = true
    }

    try {
      const formData = new FormData(form)

      // Add cart items component section IDs for updating the cart drawer
      const cartItemsComponents = document.querySelectorAll(
        'cart-items-component'
      )
      /** @type {string[]} */
      const cartItemComponentsSectionIds = []
      cartItemsComponents.forEach((item) => {
        if (item instanceof HTMLElement && item.dataset.sectionId) {
          cartItemComponentsSectionIds.push(item.dataset.sectionId)
        }
      })
      if (cartItemComponentsSectionIds.length > 0) {
        formData.append('sections', cartItemComponentsSectionIds.join(','))
      }

      const fetchCfg = fetchConfig('javascript', { body: formData })

      const response = await fetch(Theme.routes.cart_add_url, {
        ...fetchCfg,
        headers: {
          ...fetchCfg.headers,
          Accept: 'application/json'
        }
      })

      const json = await response.json()

      if (json.status) {
        // Error occurred
        console.error('Cart add error:', json.message)
        if (button instanceof HTMLButtonElement) {
          button.textContent = json.message || 'Error'
          setTimeout(() => {
            button.textContent = 'Add to cart'
          }, 2000)
        }
        return
      }

      // Success - dispatch cart add event with updated cart data
      const id = formData.get('id')
      if (id) {
        this.dispatchEvent(
          new CartAddEvent(json, id.toString(), {
            source: 'cart-form-component',
            itemCount: Number(formData.get('quantity')) || 1
          })
        )
      }
    } catch (error) {
      console.error('Error adding to cart:', error)
    } finally {
      if (button instanceof HTMLButtonElement) {
        button.disabled = false
      }
    }
  }
}

if (!customElements.get('cart-form-component')) {
  customElements.define('cart-form-component', CartFormComponent)
}
